import { ModuleSection, StatusEnum } from "./type";

export const getTrainingCourseModuleStatus = (
  trainingSection: ModuleSection,
  isMenuFormCompleted?: boolean,
) => {
  const isCourseCompleted =
    trainingSection && trainingSection.numerator! >= trainingSection.denominator!;
  if (isCourseCompleted) {
    return StatusEnum.completed;
  }
  if (isMenuFormCompleted) {
    return StatusEnum.untouched;
  }
  return StatusEnum.disabled;
};

export const getTrainingExamModuleStatus = (
  trainingSection: ModuleSection,
  examSection: ModuleSection,
) => {
  const isExamCompleted = examSection && examSection.numerator! >= examSection.denominator!;
  const isCourseCompleted =
    trainingSection && trainingSection.numerator! >= trainingSection.denominator!;
  if (isExamCompleted) {
    if (isCourseCompleted) {
      return StatusEnum.completed;
    } else {
      return StatusEnum.completedButDisabled;
    }
  }
  if (isCourseCompleted) {
    return StatusEnum.untouched;
  }
  return StatusEnum.disabled;
};
